import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import _ from 'lodash';
import { API_URL } from '../../partials/Globals';
import Message from '../../partials/Message';
import Icon from '../../partials/Icon';
import Moment from 'react-moment';
import 'moment/locale/sv';

export default class Transactions extends Component {
    state = {
        message: '',
        project: {},
        projects: [],
        project_id: '',
        school: {},
        schools: [],
        school_id: '',
        group: {},
        groups: [],
        group_id: '',
        transactions: [],
        data: {},
        search: '',
        sales: {
            shares: '',
            total: ''
        }
    }

    constructor(props) {
        super(props);

        this.chooseProject = this.chooseProject.bind(this);
        this.chooseSchool = this.chooseSchool.bind(this);
        this.inputChange = this.inputChange.bind(this);
        this.submit = this.submit.bind(this);
        this.previous = this.previous.bind(this);
        this.next = this.next.bind(this);
    }

    componentDidMount() {
        axios.get(API_URL+'/admin/projects')
            .then(response => {
                this.setState({ projects: response.data });
            });
    }

    inputChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    chooseProject(event) {
        this.setState({ 
            project_id: event.target.value,
            schools: [],
            school_id: '',
            groups: [],
            group_id: ''
        });

        if (event.target.value !== '') {
            axios.get(API_URL+'/admin/projects/'+event.target.value+'/schools')
                .then(response => {
                    this.setState({ schools: response.data });
                });
        }
    }

    chooseSchool(event) {
        this.setState({ 
            school_id: event.target.value,
            groups: [],
            group_id: ''
        });

        if (event.target.value !== '') {
            axios.get(API_URL+'/admin/projects/'+this.state.project_id+'/schools/'+event.target.value+'/groups')
                .then(response => {
                    this.setState({ groups: response.data });
                });
        }
    }

    submit(event) {
        event.preventDefault();

        axios.get(`${ API_URL }/admin/transactions?project_id=${ this.state.project_id }&school_id=${ this.state.school_id }&group_id=${ this.state.group_id }&term=${ this.state.search }`)
            .then(response => {
                console.log(response.data);
                this.setState({
                    group: response.data.group,
                    transactions: response.data.transactions.data,
                    data: response.data.transactions,
                    sales: response.data.sales
                })
            });
    }

    previous(event) {
        event.preventDefault();

        axios.get(this.state.data.prev_page_url)
            .then(response => {
                this.setState({
                    transactions: response.data.transactions.data,
                    data: response.data.transactions
                })
            });
    }

    next(event) {
        event.preventDefault();

        axios.get(this.state.data.next_page_url)
            .then(response => {
                this.setState({
                    transactions: response.data.transactions.data,
                    data: response.data.transactions
                })
            });
    }

    render() {
        const { projects, schools, groups, group, sales, transactions, data } = this.state;

        return (
            <div>
                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                    </div>
                </div>

                <Message message={ this.state.message } />

                <div className="container">
                    <div className="content">
                        <h1>Transaktioner</h1>

                        <form onSubmit={ this.submit }>
                            { projects && projects.length > 0 &&
                                <div>
                                    <label>Projekt</label>
                                    <select name="project_id" value={ this.state.project_id } onChange={ this.chooseProject }>
                                        <option value="">Välj</option>
                                        { Object.keys(projects).map(function(key) {
                                            return <option key={ key } value={ projects[key].id }>{ projects[key].title }</option>
                                        }) }
                                    </select>
                                </div>
                            }

                            { schools && schools.length > 0 &&
                                <div>
                                    <label>Organisationer</label>
                                    <select name="school_id" value={ this.state.school_id } onChange={ this.chooseSchool }>
                                        <option value="">Välj</option>
                                        { Object.keys(schools).map(function(key) {
                                            return <option key={ key } value={ schools[key].id }>{ schools[key].name }</option>
                                        }) }
                                    </select>
                                </div>
                            }

                            { groups && groups.length > 0 &&
                                <div>
                                    <label>Grupper</label>
                                    <select name="group_id" value={ this.state.group_id } onChange={ this.inputChange }>
                                        <option value="">Välj</option>
                                        { Object.keys(groups).map(function(key) {
                                            return <option key={ key } value={ groups[key].id }>{ groups[key].name }</option>
                                        }) }
                                    </select>
                                </div>
                            }

                            <label>Sökterm<br />Förnamn, efternamn, e-postadress eller telefonnummer</label>
                            <input type="text" name="search" value={ this.state.search } onChange={ this.inputChange } />

                            <input className="button purple m-top-l" type="submit" value="Hämta" />
                        </form>

                        { group && !_.isEmpty(group) && !this.state.search &&
                            <dl>
                                <dt>Sålda andelar</dt> 
                                    <dd>{ sales[0].shares } / { group.projects[0].pivot.shares } st</dd>
                                <dt>Intjänat</dt>
                                    <dd>{ (sales[0].shares*group.projects[0].pivot.group_share_cut).toString().replace(/./g, function(c, i, a) { return i && c !== "." && ((a.length - i) % 3 === 0) ? ' ' + c : c; }) } kr</dd>
                                <dt>Styckpris</dt> 
                                    <dd>{ group.projects[0].pivot.share_price } kr</dd>
                                <dt>Gruppens förtjänst per såld andel</dt> 
                                    <dd>{ group.projects[0].pivot.group_share_cut } kr</dd>
                                <dt>Startdatum</dt> 
                                    <dd>{ group.projects[0].pivot.start_date }</dd>
                                <dt>Slutdatum</dt> 
                                    <dd>{ group.projects[0].pivot.end_date }</dd>
                            </dl>
                        }

                        { transactions && transactions.length > 0 &&
                            <div className="block">
                                <div className="header">
                                    <h4>Transaktioner</h4>
                                </div>

                                <div className="body">
                                    <ul className="has-icons compressed">
                                        { Object.keys(transactions).map(function(key) {
                                            return (
                                                <li key={ key }>
                                                    { transactions[key].payment_success === 0 ? (
                                                        <Icon className="not-finished" icon="transaction" color="pink" />
                                                    ) : (
                                                        <Icon icon="transaction" color="pink" />
                                                    ) }

                                                    <Link className="regular-text wrapper" to={`/superadmin/transactions/${ transactions[key].id }`}>
                                                        <span className="right small">
                                                            <Moment locale="sv" format="D/M">{ transactions[key].created_at }</Moment><br /> <Moment locale="sv" format="HH:mm">{ transactions[key].created_at }</Moment>
                                                        </span>
                                                        { transactions[key].first_name } { transactions[key].last_name } { transactions[key].payment_success === 0 ? ( <span>påbörjade köp av { transactions[key].shares }</span>) : ( <span>köpte { transactions[key].shares }</span>) } { transactions[key].shares === 1 ? ( <span> andel</span>) : ( <span> andelar</span>) }
                                                    </Link>
                                                </li>
                                            )
                                        }) }
                                    </ul>

                                    <div className="pagination">
                                        <div className="pagination-wrapper">
                                            { data.current_page > 1 ? (
                                                <a className="prev" onClick={ this.previous }>&nbsp;</a>
                                            ) : (
                                                <a className="prev disabled">&nbsp;</a>
                                            ) }
                                            <span className="info">
                                                { data.current_page } / { data.last_page } 
                                            </span>
                                            { data.current_page < data.last_page ? (
                                                <a className="next" onClick={ this.next }>&nbsp;</a>
                                            ) : (
                                                <a className="next disabled">&nbsp;</a>
                                            ) }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/Transactions/index.js